// @ts-check
import classNames from 'classnames';
import { graphql } from 'gatsby';
import React from 'react';
import SingleImageBlock from '../components/SingleImageBlock';

import './HighlightedImageBlock.scss';

export const query = graphql`
	fragment HighlightedImageBlockFragment on Ozk_pageContent {
		image_blocks {
			alternate_orientation
			image_block {
				heading
				copy {
					json
				}
				button {
					button_text
					button_link
					open_in_new_tab
					button_style
					button_features
				}
				image {
					...BynderImageFragment
				}
				image_options {
					image {
						description
						files {
							transformBaseUrl {
								url
							}
						}
					}
				}
			}
		}
	}
`;

/**
 * @typedef HighlightedImageBlockOptions
 * @property {boolean} alternate_orientation
 * @property {import('../components/SingleImageBlock').SingleImageBlockOptions[]} image_block

 * @typedef HighlightedImageBlockProps
 * @property {import('~/contentstack/types').ModelWithLivePreviewAttr<HighlightedImageBlockOptions>} [options]
 */
/** @type {React.FC<HighlightedImageBlockProps> } */
const HighlightedImageBlock = ({ options }) => (
	<div className={classNames(['highlighted-image-block', { alternate: !!options.alternate_orientation }])} {...options.$?.alternate_orientation}>
		{options.image_block?.map((b, i) => (
			<SingleImageBlock options={b} key={i} />
		))}
	</div>
);

export default HighlightedImageBlock;
